var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalkinOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 40,
    height: 40,
    rx: 4,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4317_25619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 0C41.3137 0 44 2.68629 44 6V17.1553C43.9119 17.1471 43.8227 17.1426 43.7324 17.1426C42.1545 17.1426 40.875 18.422 40.875 20C40.875 21.578 42.1545 22.8574 43.7324 22.8574C43.8227 22.8574 43.9119 22.8519 44 22.8438V34C44 37.3137 41.3137 40 38 40H10C6.68629 40 4 37.3137 4 34V6C4 2.68629 6.68629 1.28851e-07 10 0H38Z",
    fill: "#04B7B1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3773 12.282C31.1889 12.4053 32.7563 11.0366 32.8797 9.22497C33.003 7.41338 31.6342 5.84591 29.8226 5.72256C28.011 5.59927 26.4436 6.96803 26.3202 8.77962C26.1969 10.5912 27.5657 12.1587 29.3773 12.282Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6961 18.0859H36.4043C36.9465 18.0859 37.3856 18.6282 37.3856 19.0672V19.8963C37.3856 20.4385 36.9465 20.8776 36.4043 20.8776H10.6961C10.1539 20.8776 9.71484 20.3353 9.71484 19.8963V19.0672C9.71484 18.525 10.1539 18.0859 10.6961 18.0859Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4307 31.6758H34.6261C34.9809 31.6758 35.2677 32.0306 35.2677 32.3174V33.2521C35.2677 33.6069 34.9796 33.8937 34.6261 33.8937H31.4307C31.0759 33.8937 30.7891 33.5389 30.7891 33.2521V32.3174C30.7891 31.9626 31.0772 31.6758 31.4307 31.6758Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.668 21.8828H34.3904V30.6689H31.668V21.8828Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4736 31.6758H15.6691C16.0239 31.6758 16.3107 32.0306 16.3107 32.3174V33.2521C16.3107 33.6069 16.0226 33.8937 15.6691 33.8937H12.4736C12.1189 33.8937 11.832 33.5389 11.832 33.2521V32.3174C11.832 31.9626 12.1201 31.6758 12.4736 31.6758Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7109 21.8828H15.4333V30.6689H12.7109V21.8828Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7136 21.8828H20.5149L18.6127 32.0995C18.4504 33.0368 19.1726 33.8948 20.1236 33.8948H20.2759C21.008 33.8948 21.6371 33.3777 21.7805 32.6606L23.8261 23.4342L26.3573 26.1215L25.5811 32.1952C25.4817 33.1022 26.1925 33.8948 27.1058 33.8948C27.872 33.8948 28.5211 33.3287 28.6256 32.5688L29.6987 25.7099C29.7477 25.3954 29.6836 25.0733 29.515 24.8016L27.7122 21.8829L27.7136 21.8828Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6102 18.0151C18.2405 18.2441 18.9035 17.8843 19.0759 17.2678L20.5289 13.0811L23.9975 12.5753L21.7645 17.079H28.3567L29.1392 15.6184L29.7255 17.079H32.468L31.5723 13.7489C31.483 13.4747 31.3484 13.2218 31.1798 12.9941C30.6904 13.1891 30.1595 13.296 29.6047 13.296C29.5066 13.296 29.4084 13.2922 29.3103 13.2859C27.1691 13.14 25.5023 11.4391 25.3274 9.36195C25.0443 9.34559 24.7563 9.37327 24.477 9.45001L19.2773 10.8565C18.9301 10.9509 18.6533 11.2151 18.5451 11.5585L16.9348 16.631C16.7851 17.1971 17.0619 17.8173 17.6117 18.0173L17.6102 18.0151Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4317_25619",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4317_25619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4317_25619",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkinOn);
export default __webpack_public_path__ + "static/media/WalkinOn.66e5b48a0d2b056be09a9e1dae19199f.svg";
export { ForwardRef as ReactComponent };